(function () {
  var AUTO_DISMISS = 4500;

  function container() {
    var c = document.getElementById('cart-notifs');
    if (!c) { c = document.createElement('div'); c.id = 'cart-notifs'; document.body.appendChild(c); }
    return c;
  }
  function fmtPrice(cents) {
    if (typeof cents !== 'number') return '';
    if (window.Shopify && typeof Shopify.formatMoney === 'function') return Shopify.formatMoney(cents);
    return (cents / 100).toFixed(2);
  }

  window.cartNotify = function (item) {
    if (!item || item.status) return; // ignore les erreurs

    var title   = item.product_title || item.title || '';
    var variant = (item.variant_title && item.variant_title !== 'Default Title') ? item.variant_title : '';
    var qty     = item.quantity || 1;
    var img     = item.image || '';
    var price   = (typeof item.final_line_price === 'number') ? item.final_line_price : null;

    var el = document.createElement('div');
    el.className = 'cart-notif';
    el.innerHTML =
      '<div class="cart-notif__row">' +
        (img ? '<span class="cart-notif__img"><img src="' + img + '" alt="" loading="lazy"></span>' : '') +
        '<div class="cart-notif__body">' +
          '<span class="cart-notif__label"><i aria-hidden="true" class="icon-check"></i> Ajouté au panier</span>' +
          '<span class="cart-notif__title">' + title + '</span>' +
          (variant ? '<span class="cart-notif__meta">' + variant + '</span>' : '') +
          '<span class="cart-notif__meta">Qté&nbsp;: ' + qty + (price != null ? ' · ' + fmtPrice(price) : '') + '</span>' +
        '</div>' +
      '</div>';

    var timer;
    function dismiss() {
      clearTimeout(timer);
      el.classList.add('is-out'); el.classList.remove('is-in');
      setTimeout(function () { if (el.parentNode) el.parentNode.removeChild(el); }, 450);
    }
    el.addEventListener('click', dismiss);
    el.addEventListener('mouseenter', function () { clearTimeout(timer); el.classList.add('is-paused'); });
    el.addEventListener('mouseleave', function () { el.classList.remove('is-paused'); timer = setTimeout(dismiss, 1500); });

    container().appendChild(el);
    requestAnimationFrame(function () { requestAnimationFrame(function () { el.classList.add('is-in'); }); });
    timer = setTimeout(dismiss, AUTO_DISMISS);
  };
})();